// sdf
// om
import { useState, useRef, useEffect, useMemo } from "react"
import { Button, Col, Form, Row, Modal } from "react-bootstrap"
import {
  faArrowRightLong,
  faCloudUpload,
  faIndianRupeeSign,
  faPen,
  faPlus,
  faXmark,
} from "@fortawesome/free-solid-svg-icons"
import {
  IconXboxX
} from "@tabler/icons-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Select, { components } from "react-select"
import { useNavigate, useParams } from "react-router-dom"
import infoImg from "../../Utils/assets/img/icons/info_icon.png"
import { GetRequest, PostRequest } from "../../Utils/hooks/ApiHandler"
import useLocalStorageState from "use-local-storage-state"
import { z } from "zod"
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { toast } from "sonner"
import { PurchaseAddressModal } from "./PurchaseAddressModal"
import { customStyles } from "../../Utils/helpers/commonhelper"
import { imageURL } from "../../Utils/constants/constant"
import { ContactForm } from "../education/Contacts/ContactModule/ContactForm";
import { getCountries } from "../../Utils/hooks/location";

const idString = (msg) =>
  z.preprocess((val) => {
    if (val == null) return ""
    if (typeof val === "object") {
      if ("value" in val) return String(val.value ?? "")
      return ""
    }
    return String(val)
  }, z.string().min(1, msg))

const asDateString = (msg) =>
  z.preprocess((val) => {
    if (val instanceof Date) return val.toISOString()
    return val
  }, z.string().min(1, msg))

//menulist for add new products and services button in dropdown
const MenuList = (props) => {
  const { moduleType, canCreate } = props.selectProps

  return (
    <>
      <components.MenuList {...props}>
        {props.children}
        <div
          style={{
            padding: "10px",
            borderTop: "1px solid #ddd",
            textAlign: "center",
            cursor: "pointer",
            color: "#0d6efd",
            fontWeight: 500,
          }}
          onClick={() => {
            if (!canCreate && moduleType === "contact") {
              toast.warning("You are not authorized for this action!")
              return
            }
            // trigger your modal open here
            props.selectProps.onAddNew()
          }}
        >
          + Add New
        </div>
      </components.MenuList>
    </>
  )
}

const CreatePurchaseOrderSchema = z
  .object({
    contact: z.string().min(1, "Contact name is required"),
    reference: z.string().optional(),
    purchaseOrderDate: asDateString("Purchase Order date is required"),
    expectedDeliveryDate: asDateString(
      "Expected delivery date is required"
    ).refine((date) => new Date(date) >= new Date(), {
      message: "Expected delivery date cannot be in the past",
    }),
    poGeneratedBy: idString("enter generated by name"),
    gstnNumber: z.string().min(15, "Please enter valid GSTN number").max(15, "Please enter valid GSTN number"),
    shortDescription: z.string().min(1, "Short description is required"),
    items: z
      .array(
        z.object({
          item: z.preprocess(
            (val) => {
              if (val == null) return null
              if (typeof val === "string" || typeof val === "number") {
                const s = String(val)
                return { value: s, label: s }
              }
              return val
            },
            z
              .object({
                value: z.string(),
                label: z.string(),
              })
              .nullable()
              .refine((val) => val !== null, { message: "Item is required" })
          ),
          quantity: z.coerce.number().min(1, "Quantity must be at least 1"),
          rate: z.coerce.number().min(0, "Rate must be a positive number"),
          gst: z.coerce
            .number()
            .min(0, "GST must be a positive number")
            .optional(),
          discount: z.coerce
            .number()
            .min(0, "Discount must be a positive number")
            .max(100, "Discount cannot exceed 100%")
            .optional(),
          discountType: z.string().optional(),
          amount: z.string().optional(),
          description: z.string().optional(),
        })
      )
      .min(1, "At least one item is required"),
    termsConditions: z.string().optional(),
    attachment: z.any().optional(),
    customerNote: z.string().optional(),
    specialDiscount: z.coerce
      .number()
      .min(0, "Discount must be a positive number")
      .optional(),
    specialDiscountType: z.string().optional(),
    gstPercentage: z.coerce
      .number()
      .min(0, "GST must be a positive number")
      .optional(),
  })
  .refine(
    (data) => {
      // Ensure expected delivery date is not before purchase order date
      const poDate = new Date(data.purchaseOrderDate)
      const deliveryDate = new Date(data.expectedDeliveryDate)
      return deliveryDate >= poDate
    },
    {
      message: "Expected delivery date cannot be before purchase order date",
      path: ["expectedDeliveryDate"], // This shows the error on the expectedDeliveryDate field
    }
  )

export const CreatePurchaseOrder = () => {
  const { id } = useParams()

  const [poNumber, setPoNumber] = useState("")
  // contact listing
  const [contactOption, setContactOption] = useState([])
  // po generated by dropdown listing
  const [leadOwner, setLeadOwner] = useState([])
  //products listing
  const [productOption, setProductOption] = useState([])
  // items in table data
  const [customer, setCustomer] = useLocalStorageState("customer")
  const navigate = useNavigate()
  const [existingFile, setExistingFile] = useState(null)
  const [draftClicked, setDraftClicked] = useState(false)
  const customerId = customer?.customer_details?.customer_id
  const userLoginId = customer?.customer_details?.id
  const token = customer?.token?.authorization
  const rf = customer?.token?.authentication

  const headers = {
    authentication: rf,
    Authorization: token,
  }
  const extras = { customer, setCustomer, rf, navigate }
  const [text, setText] = useState("")
  const [show, setShow] = useState(false)
  // purchase order id
  const [po_id, setPoId] = useState(null)
  //loading state when approve is done
  const [isApproving, setIsApproving] = useState(false)
  // normal page loading state
  const [isLoading, setIsLoading] = useState(false)
  // country state for contact form
  const [country, setCountries] = useState([{ countryName: "", countryId: 0 }])
  // state for tracking discount validation errors
  const [discountErrors, setDiscountErrors] = useState({})
  const [specialDiscountError, setSpecialDiscountError] = useState("")

  const today = new Date().toISOString().split("T")[0] // YYYY-MM-DD
  const tomorrowDate = new Date()
  tomorrowDate.setDate(tomorrowDate.getDate() + 1)
  const tomorrow = tomorrowDate.toISOString().split("T")[0]


  const formatDateForInput = (dateString) => {
    if (!dateString) return ""
    const date = new Date(dateString)
    return date.toISOString().split("T")[0]
  }

  const {
    reset,
    handleSubmit,
    control,
    watch,
    setValue,
    register,
    formState: { errors, isDirty, isValid },
  } = useForm({
    resolver: zodResolver(CreatePurchaseOrderSchema),
    mode: "onChange",
    defaultValues: {
      modules: [],
      items: [{ item: null, rate: "", gst: "", quantity: 1 }],
      purchaseOrderDate: formatDateForInput(today),
      expectedDeliveryDate: formatDateForInput(tomorrow),
    },
  })
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  })

  const handleClose = () => setShow(false)

  const [showTextarea, setShowTextarea] = useState(false)
  const [selectedContact, setSelectedContact] = useState("")

  const [file, setFile] = useState(null)
  const fileInputRef = useRef(null)

  // holdings array of object to calculate and store the % of holding in the total amount
  const [holdings, setHoldings] = useState(null)

  const [discountMoney, setDiscountMoney] = useState(0)

  //   subtotal field
  const [subtotal, setSubTotal] = useState(0)
  // grand total state
  const [grandTotal, setgrandTotal] = useState(0)

  // gst categories
  const [gstCategories, setGstCategories] = useState([])
  // total gst amount of all categories
  const [totalGstAmount, setTotalGstAmount] = useState(0)

  const [isDragging, setIsDragging] = useState(false);
  // state for description respective to each item
  const [addDescriptionMap, setAddDescriptionMap] = useState({})

  const [addressModal, setAddressModal] = useState(false)
  const [defaultFor, setDefaultFor] = useState("")

  // billing address state
  const [billingAdd, setBillingAdd] = useState([])

  // editMode
  const [isEditMode, setIsEditMode] = useState(false)

  // permissions
  const permission = customer.customer_details?.permission
  const user_type = Number(customer.customer_details?.user_type)

  // company permissions while creating contact
  const companyPermission = permission?.filter(c => c.module_name === "company")
  const companyGrants = {
    isCreate: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.create)) : true,
  }

  const leadSourcePermission = permission?.filter(
    (c) => c.module_name === "setting",
  )
  const masterGrant = {
    isCreate:
      user_type !== 1
        ? Boolean(
          Number(
            leadSourcePermission?.find((c) => c.feature_name === "master")
              ?.create,
          ),
        )
        : true,
  }

  const contactPermission = permission?.filter(c => c.module_name === "contact")
  const contactGrant = {
    isCreate: user_type !== 1 ? Boolean(Number(contactPermission?.find(c => c.feature_name === "contact")?.create)) : true,
  }

  // to add new contact
  const [showCreateContact, setShowCreateContact] = useState(false)
  const [recentContact, setRecentContact] = useState({
    recentContactId: "",
    recentContactName: "",
  })

  // Fetch countries when component mounts
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await getCountries()
        if (data) {
          setCountries(
            data.map((c) => ({
              countryName: c.name,
              countryId: c.id,
            })),
          )
        }
      } catch (err) {
        return
      }
    }
    if (showCreateContact) {
      fetchCountries()
    }
  }, [showCreateContact])

  // Custom validation function for individual item discounts
  const validateItemDiscount = (index, value, discountType) => {
    const qty = Number(watch(`items.${index}.quantity`) || 1)
    const rate = Number(watch(`items.${index}.rate`) || 0)
    const numValue = Number(value)
    if (discountType === "PERCENT" && numValue > 100) {
      setDiscountErrors((prev) => ({
        ...prev,
        [index]: "Discount cannot exceed 100%",
      }))
      return false
    } else if (discountType === "INR") {
      const itemTotal = rate * qty
      if (numValue > itemTotal) {
        setDiscountErrors((prev) => ({
          ...prev,
          [index]: "Discount cannot exceed item total amount",
        }))
        return false
      }
    } else {
      setDiscountErrors((prev) => {
        const updated = { ...prev }
        delete updated[index]
        return updated
      })
      return true
    }
  }

  // Custom validation function for special discount
  const validateSpecialDiscount = (value, discountType) => {
    const numValue = Number(value)

    if (discountType === "PERCENT" && numValue > 100) {
      setSpecialDiscountError("Special discount cannot exceed 100%")
      return false
    } else if (discountType === "INR" && numValue > Number(subtotal)) {
      setSpecialDiscountError("Special discount cannot exceed total amount")
      return false
    } else {
      setSpecialDiscountError("")
      return true
    }
  }

  const handleChange = (e) => {
    setFile(e.target.files[0])
  }

  const handleClickButton = () => {
    fileInputRef.current.click()
  }

  const handleChangeTextArea = () => {
    setShowTextarea((prev) => !prev)
    setText("")
  }
  // const handleDraftClick = () => {
  //   setDraftClicked(true)
  // }

  // fetch po number
  const fetchPoNumber = async () => {
    const res = await GetRequest(
      `common/fetchPrefixSeries/${customerId}/purchase`,
      { headers },
      { extras }
    )
    setPoNumber("#" + res.data?.prefix + "-" + res.data?.incremental_number)
  }

  useEffect(() => {
    fetchPoNumber()
  }, [])


  const handleFile = (selectedFile) => {
    if (!selectedFile) return;
    setFile(selectedFile);
    setValue("attachment", selectedFile);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const droppedFile = e.dataTransfer.files[0];
    handleFile(droppedFile);
  };

  const fetchBillingAddress = async () => {
    try {
      const res = await GetRequest(
        `purchase/fetchBillingAddress/${customerId}`,
        { headers },
        extras
      )

      if (res.status === "fail" || res.success === false) {
        toast.error(res.message)
        return
      }
      if (!res.data) return
      let processedAddresses = []
      // Check if billing_address exists and is not null
      const parsedBillingAdd = JSON.parse(res.data.billing_address)
      if (
        res.data.billing_address !== null &&
        Array(parsedBillingAdd).length !== 0
      ) {
        processedAddresses = parsedBillingAdd.map((c) => ({
          address: c.address,
          country: c.country,
          state: c.state,
          city: c.city,
          zipcode: c.zipcode,
          selected: c.selected,
          for: c.for,
        }))
      } else {
        // Handle case where billing_address is null - use direct data properties
        processedAddresses = [
          {
            address: res.data.address,
            country: res.data.nicename,
            state: res.data.state_name,
            city: res.data.city_name,
            zipcode: res.data.pincode,
            selected: "selected",
            for: null,
          },
        ]
      }

      // Set the state directly with the processed addresses (don't spread with prev)
      setBillingAdd(processedAddresses)
    } catch (error) {
      toast.error("Error Fetching Address")
    }
  }
  useEffect(() => {
    fetchBillingAddress()
  }, [customerId])


  const fetchEditData = async () => {
    if (!id || !customerId || id === "null") return
    setIsEditMode(true)
    try {
      const res = await GetRequest(
        `purchase/fetchDetailsOfPOById/${id}/${customerId}`,
        { headers },
        extras
      )
      if (res.status === "fail") {
        toast.error(res.message)
        return
      }
      const data = res.data
      // Parse and set PO number for edit mode
      if (data.po_number) {
        setPoNumber("#" + data.po_number)
      }

      // Parse items from edit data
      const parsedItems = data?.items ? JSON.parse(data.items) : []
      const itemsData =
        parsedItems[0]?.itemDetails?.map((item) => ({
          item: {
            value: item.item_id || item.product_id,
            label: item.name,
          },
          quantity: item.quantity || 1,
          rate: item.Rate || item.rate || 0,
          gst: item.gst || 0,
          discount: item.discout || item.discount,
          discountType: item.discountType,
          amount: item.amount || 0,
          description: item.description || "",
        })) || []

      // Calculate discount money from the fetched data
      let discountMoney = 0
      const specialDiscount = parsedItems[0]?.["special-discount"] || 0
      const specialDiscountType =
        parsedItems[0]?.special_discount_type || "PERCENT"
      if (specialDiscount > 0) {
        let subtotal = parsedItems[0]?.["sub-total"] || 0
        if (specialDiscountType === "PERCENT") {
          discountMoney = (subtotal / 100) * specialDiscount
        } else if (specialDiscountType === "INR") {
          discountMoney = specialDiscount
        }
      }

      setPoId(data?.id)
      setDiscountMoney(Number(discountMoney).toFixed(2))
      setgrandTotal(Number(parsedItems[0]?.["grand-total"]))

      const gstArray = Object.keys(parsedItems[0])
        .filter((key) => key.startsWith("gst_"))
        .map((key) => {
          return {
            gstCategory: key.split("_")[1] + "%", // take the number part and add %
            totalAmt: Number(parsedItems[0][key]),
          }
        })

      setGstCategories(gstArray)
      if (data.attachment) {
        const fileName = data.attachment.split("/").pop()
        const fullUrl = `${imageURL}${data.attachment}`

        setExistingFile({
          name: fileName,
          url: fullUrl,
          path: data.attachment,
        })

        setFile(null)
      }

      // Reset form with fetched data
      reset({
        contact: data.contact_id || "",
        reference: data.reference_number || "",
        purchaseOrderDate: formatDateForInput(data.po_date),
        expectedDeliveryDate: formatDateForInput(data.expected_delivery_date),
        poGeneratedBy: data.owner_id || "",
        gstnNumber: data.gstn_no || "",
        shortDescription: data.description || "",
        items: itemsData,
        termsConditions: data.terms_condition || "",
        customerNote: data.customer_note || "",
        attachment: data.attachment,
        specialDiscount: specialDiscount,
        specialDiscountType: specialDiscountType,
      })
    } catch (error) {
      toast.error("Failed to load purchase order data")
    }
  }

  useEffect(() => {
    if (id && customerId) {
      fetchEditData()
    }
  }, [id, customerId, contactOption, reset])

  useEffect(() => {
    if (!isDirty) {
      fetchEditData()
    }
  }, [isDirty])

  // Fetch All contacts
  const fetchAllContacts = async () => {
    setIsLoading(true)
    try {
      const res = await GetRequest(
        `quotation/fetchContacts/${customer?.customer_details?.id}/${customer.customer_details.customer_id}/${customer?.customer_details?.user_type}`,
        { headers },
        extras
      )

      if (res.status === "fail" || res.status !== "success") {
        return toast.error(res.message || "failed to find contacts")
        setIsLoading(false)

      }

      if (res.status === "success") {
        const data = res.data.map((contact) => ({
          contactName: contact.contact_full_name,
          contactId: contact.id,
          company_name: contact.company_name,
        }))
        setContactOption(data)
        res?.data &&
          res.data.find((c) => {
            if (c.id === recentContact.recentContactId) {
              setValue("contact", recentContact.recentContactId)
              setRecentContact((prev) => ({
                ...prev,
                recentContactName: c.contact_full_name,
              }))
            }
          })
        setIsLoading(false)

      }
    } catch (error) {
      setIsLoading(false)
      return
    }
  }

  useEffect(() => {
    fetchAllContacts()
  }, [recentContact.recentContactId])

  // lead owner for po generated by dropdown
  // Fetch All contacts
  const fetchAllPoGeneratedByList = async () => {
    try {
      const res = await GetRequest(
        `users/users/fetchUserAsOwner/${customerId}`,
        { headers },
        extras
      )

      if (res.status === "fail" || res.status !== "success") {
        return toast.error(res.message || "failed to find contacts")
      }

      if (res.status === "success") {
        const data = res.data.map((leads) => ({
          leadOwnerName: leads.full_name,
          leadOwnerId: leads.id,
        }))
        setLeadOwner(data)
      }
    } catch (error) {
      return
    }
  }

  useEffect(() => {
    fetchAllPoGeneratedByList()
  }, [])

  // fetch all products list in dropdown
  const fetchAllProductById = async () => {
    try {
      const res = await GetRequest(
        `/masters/getProducts/${customerId}`,
        { headers },
        extras
      )

      if (res.status !== "success") {
        return toast.error(res.message)
      }

      // Store the full product data
      const data = res.data.map((product) => ({
        productName: product.service,
        productId: product.id,
        productPrice: product.price,
        productGST: product.tax,
      }))
      setProductOption(data)
    } catch (error) {
      return
    }
  }
  useEffect(() => {
    fetchAllProductById()
  }, [])

  const handleSelectChange = (name, selectedOption, fieldOnChange) => {
    fieldOnChange(selectedOption?.value || "")

    // Update local state for selected values
    if (name === "contact") {
      setSelectedContact(selectedOption)
    }
  }

  const contactOptions = useMemo(
    () =>
      contactOption.map((conta) => ({
        value: conta.contactId,
        label: conta.contactName,
        company_name: conta.company_name,
      })),
    [contactOption]
  )

  // Custom option component for better formatting (optional)
  const CustomOption = ({
    innerRef,
    innerProps,
    data,
    isSelected,
    isFocused,
  }) => (
    <div
      ref={innerRef}
      {...innerProps}
      style={{
        padding: "8px 12px",
        backgroundColor: isSelected
          ? "#007bff"
          : isFocused
            ? "#f8f9fa"
            : "white",
        color: isSelected ? "white" : "#333",
        cursor: "pointer",
      }}
    >
      <div style={{ fontWeight: "500" }}>{data.label}</div>
      <div
        style={{ fontSize: "12px", color: isSelected ? "#e9ecef" : "#6c757d" }}
      >
        {data.company_name || "No Company"}
      </div>
    </div>
  )

  const leadOwnerOptions = useMemo(() =>
    leadOwner.map((lead) => ({
      value: lead.leadOwnerId,
      label: lead.leadOwnerName,
    }))
  )

  const productListingOptions = useMemo(() =>
    productOption.map((product) => ({
      value: product.productId,
      label: product.productName,
      price: product.productPrice,
      tax: product.productGST,
    }))
  )

  // Function to get filtered options for a specific dropdown
  const getFilteredOptions = (currentIndex) => {
    // Get all selected product IDs except for the current item
    const selectedProductIds = fieldsArr
      .map((item, idx) => (idx !== currentIndex ? item?.item?.value : null))
      .filter(Boolean)

    // Filter out already selected products
    return productListingOptions.filter(
      (option) => !selectedProductIds.includes(option.value)
    )
  }

  const handleUpdateAmount = (index) => {
    const qty = Number(watch(`items.${index}.quantity`) || 1)
    const rate = Number(watch(`items.${index}.rate`) || 0)
    const discount = Number(watch(`items.${index}.discount`) || 0)
    const discountType = watch(`items.${index}.discountType`)
    let total = qty * rate

    // Validate discount before calculating
    if (discountType === "PERCENT" && discount > 100) {
      setDiscountErrors((prev) => ({
        ...prev,
        [index]: "Discount cannot exceed 100%",
      }))
      total = 0 // Set to 0 if invalid
    } else if (discount >= 0 && discount <= 100) {
      // Clear error for this field
      setDiscountErrors((prev) => {
        const updated = { ...prev }
        delete updated[index]
        return updated
      })

      if (discountType === "PERCENT") {
        total -= (total * discount) / 100
      } else if (discountType === "INR") {
        total -= discount
      }
    } else {
      total = 0
    }
    setValue(`items.${index}.amount`, total.toFixed(2))
  }

  // subtotal calculate
  const fieldsArr = useWatch({ control, name: "items" }) || []

  useEffect(() => {
    if (fieldsArr.length === 0) {
      setHoldings([])
      setSubTotal(0)
      return
    }

    const total = fieldsArr.reduce((acc, item) => {
      return acc + Number(item.amount || 0)
    }, 0)

    const holdingArr = fieldsArr.map((item) => {
      const amount = Number(item.amount)
      const itemHolding = total > 0 ? (amount / total) * 100 : 0

      // Get existing finalAmt from current holdings if it exists, otherwise use original amount
      const existingHolding = holdings?.find((h) => h.id === item.item?.value)
      const finalAmt =
        existingHolding?.finalAmt !== undefined
          ? existingHolding.finalAmt
          : amount

      return {
        id: item.item?.value || null,
        holding: itemHolding.toFixed(2),
        finalAmt: finalAmt,
      }
    })
    setHoldings(holdingArr)
    setSubTotal(total)
  }, [fieldsArr])

  // calculating the final total after special discount
  const specialDisc = watch("specialDiscount")
  const specialDiscType = watch("specialDiscountType")

  const calculateDiscounts = (specialDisc, specialDiscType) => {
    // Validate special discount first
    if (specialDiscType === "PERCENT" && specialDisc > 100) {
      setSpecialDiscountError("Special discount cannot exceed 100%")
      setDiscountMoney(0)
      return
    } else if (specialDiscType === "INR" && specialDisc > Number(subtotal)) {
      setSpecialDiscountError("Special discount cannot exceed total amount")
      setDiscountMoney(0)
      return
    } else {
      setSpecialDiscountError("")
    }

    if (specialDisc >= 0 && subtotal > 0) {
      let discountMoney
      if (specialDiscType === "PERCENT") {
        discountMoney = (subtotal / 100) * specialDisc
      } else if (specialDiscType === "INR") {
        discountMoney = specialDisc
      }
      setDiscountMoney(Number(discountMoney).toFixed(2))

      // Update holdings with final amounts after discount
      const updatedHoldings = holdings?.map((holding) => {
        const fieldItem = fieldsArr?.find(
          (item) => item.item?.value === holding.id
        )
        if (fieldItem) {
          const amtAfterDiscount =
            (discountMoney / 100) * Number(holding.holding)

          const finalAmt =
            Number(fieldItem.amount) - amtAfterDiscount.toFixed(2)
          return {
            ...holding,
            finalAmt: finalAmt,
          }
        }
        return holding
      })

      setHoldings(updatedHoldings)
    } else {
      setDiscountMoney(0)
      // Reset finalAmt to original amounts when discount is 0
      const resetHoldings = holdings?.map((holding) => {
        const fieldItem = fieldsArr?.find(
          (item) => item.item?.value === holding.id
        )
        if (fieldItem) {
          return {
            ...holding,
            finalAmt: Number(fieldItem.amount || 0),
          }
        }
        return holding
      })
      setHoldings(resetHoldings)
    }
  }

  useEffect(() => {
    if (!isDirty) return
    calculateDiscounts(specialDisc, specialDiscType)
  }, [specialDisc, specialDiscType, subtotal])

  const discountTypeOptions = [
    { value: "PERCENT", label: "%" },
    { value: "INR", label: "₹" },
  ]

  const itemDiscountOptions = [
    { value: "PERCENT", label: "%", icon: "bi bi-percent" },
    { value: "INR", label: "₹", icon: "ti ti-currency-rupee" },
  ]
  // new product add handler
  const addRow = () => {
    append({
      item: "",
      quantity: 1,
      rate: 0,
      discount: 0.0,
      discountType: "PERCENT",
      description: "",
      gst: 0,
    })
  }

  // to delete the existing product
  const handleDeleteRow = (indexToDelete) => {
    remove(indexToDelete)
  }

  const customStyle = {
    control: (provided) => ({
      ...provided,
      padding: "0rem 0.5rem 0rem",
      minHeight: "35px",
      maxHeight: 38,
      backgroundPosition: "right 0.4rem center",
      border: "1px solid #ccc",
      boxShadow: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: "0rem 0px 0.2rem",
      fontSize: "0.9rem",
    }),
  }

  // now i have to calculate the gst amount for each item id with respect from the amount that i stored in the holdings array.

  // for this i can create a state of gst which will be responsible for storing the total amount for each gst category. for example :
  //             [
  //               {gstCategory : "5%", totalAmt : ''},
  //             ]

  // like this i will keep on appending more gst categories which would be responsible for rendering
  useEffect(() => {
    if (!isDirty) return
    if (!holdings || holdings.length === 0 || fieldsArr.length === 0) {
      setGstCategories([])
      setTotalGstAmount(0)
      return
    }
    // Create a map to accumulate GST amounts by GST category
    const gstMap = new Map()
    let grandTotalGst = 0

    fieldsArr.forEach((item) => {
      const holdingItem = holdings.find((c) => c.id === item.item?.value)
      if (holdingItem && item.gst) {
        const gstPercentage = item.gst
        const finalAmount = holdingItem.finalAmt || 0
        // Calculate GST amount (5% of final amount)
        const gstAmount = (finalAmount * gstPercentage) / 100
        // If this GST category doesn't exist in the map, initialize it
        if (!gstMap.has(gstPercentage)) {
          gstMap.set(gstPercentage, {
            gstCategory: `${gstPercentage}%`,
            totalAmt: 0,
          })
        }

        // Update the category total with GST amount
        const categoryData = gstMap.get(gstPercentage)
        categoryData.totalAmt += gstAmount
        // Add to grand total
        grandTotalGst += gstAmount
      }
    })

    // Convert the map to an array and update state
    const gstArray = Array.from(gstMap.values())
    setGstCategories(gstArray)
    setTotalGstAmount(grandTotalGst)
    setgrandTotal((subtotal - discountMoney + grandTotalGst).toFixed(2))
  }, [holdings, fieldsArr])

  // all fields
  const handleSendApprove = async (allData) => {
    if (allData.specialDiscount >= 0) {
      if (!validateSpecialDiscount(allData.specialDiscount, allData.specialDiscountType)) {
        return toast.error("Please correct the Special Discount value")
      }
    }

    setIsApproving(true)
    try {
      const approvePayload = {
        po_id: po_id,
        customer_id: customer.customer_details?.customer_id,
        contact_id: allData.contact,
        po_number: poNumber.split("#")[1] || "",
        po_date: allData.purchaseOrderDate || "",
        expected_delivery_date: allData.expectedDeliveryDate || "",
        owner_id: allData.poGeneratedBy,
        gstn_no: allData.gstnNumber,
        description: allData.shortDescription,
        customer_note: allData.customerNote,
        terms_condition: allData.termsConditions,
        reference_number: allData.reference || "",
        attachment: (file ?? existingFile?.path) || "",
        quotation_status: draftClicked ? "draft" : "pending",
        user_login_id: customer.customer_details?.id,
        billing_address: billingAdd.find((c) => c?.selected === "selected"),
        shipping_address: billingAdd.find((c) => c?.for === "shipping"),
        items:
          [
            {
              itemDetails: fieldsArr.map((item) => ({
                item_id: item.item.value,
                name: item.item?.label,
                quantity: item.quantity,
                Rate: item.rate,
                gst: item.gst,
                discout: item.discount <= 100 ? item.discount : 0,
                amount: item.amount,
                discountType: item.discountType,
                description: item.description,
              })),
              "sub-total": subtotal,
              "special-discount":
                allData.specialDiscount <= 100 ? allData.specialDiscount : 0,
              gst_5:
                gstCategories?.find((category) => category.gstCategory === "5%")
                  ?.totalAmt || 0,
              gst_18:
                gstCategories?.find(
                  (category) => category.gstCategory === "18%"
                )?.totalAmt || 0,
              gst_40:
                gstCategories?.find(
                  (category) => category.gstCategory === "40%"
                )?.totalAmt || 0,
              "gst-breakdown": [
                {
                  gst: 5,
                  amount:
                    gstCategories?.find(
                      (category) => category.gstCategory === "5%"
                    )?.totalAmt || 0,
                },
                {
                  gst: 18,
                  amount:
                    gstCategories?.find(
                      (category) => category.gstCategory === "18%"
                    )?.totalAmt || 0,
                },
                {
                  gst: 40,
                  amount:
                    gstCategories?.find(
                      (category) => category.gstCategory === "40%"
                    )?.totalAmt || 0,
                },
              ],
              "grand-total":
                Number(
                  (subtotal - discountMoney + totalGstAmount).toFixed(2)
                ) || 0,
              special_discount_type: specialDiscType,
              "gst-breakdown": [
                {
                  gst: 5,
                  amount:
                    gstCategories?.find(
                      (category) => category.gstCategory === "5%"
                    )?.totalAmt || 0,
                },
                {
                  gst: 18,
                  amount:
                    gstCategories?.find(
                      (category) => category.gstCategory === "18%"
                    )?.totalAmt || 0,
                },
                {
                  gst: 40,
                  amount:
                    gstCategories?.find(
                      (category) => category.gstCategory === "40%"
                    )?.totalAmt || 0,
                },
              ],
            },
          ] || [],
      }

      let res
      if (isEditMode) {
        res = await PostRequest(
          "purchase/updatePurchaseOrder/",
          approvePayload,
          true,
          { headers },
          extras
        )
      } else {
        res = await PostRequest(
          "purchase/createPurchaseOrder/",
          approvePayload,
          true,
          { headers },
          extras
        )
      }
      if (res.status === false || res.status === "fail") {
        setDraftClicked(false)
        setIsApproving(false)
        toast.error(res.message)
        return
      }
      if (res.status === "success") {
        toast.success(res.message)
        reset()
        setIsApproving(false)
        setIsEditMode(false)
        setDraftClicked(false)
        navigate("/purchaseOrder")
      }
    } catch (e) {
      setIsApproving(false)
      setDraftClicked(false)
      toast.error("Error Approving!")
    }
  }

  // Format number to INR format
  const formatToINR = (amount) => {
    if (!amount && amount !== 0) return "₹0.00"
    const num = typeof amount === "string" ? parseFloat(amount) : amount
    if (isNaN(num)) return "₹0.00"
    return `₹${num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`
  }

  return (
    <>
      {(isApproving || isLoading) && (
        <>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1000,
              borderRadius: "inherit",
            }}
          >
            <div className="d-flex flex-column align-items-center">
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <div className="mt-2 text-primary fw-semibold">{isApproving ? "Approving..." : "Loading..."}</div>
            </div>
          </div>
        </>
      )}
      <div
        style={{
          borderRadius: 7,
          background: "#fff",
          height: "calc(100vh - 12vh)",
          border: "1px solid lightblue",
          overflow: "clip",
        }}
      >
        <div
          className="header mb-0 position-sticky top-0 p-3 "
          style={{
            borderBottom: "1px solid lightblue",
            zIndex: 11,
            background: "#fff",
          }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <h3
              className=" mb-0"
              style={{
                whiteSpace: "nowrap",
                fontWeight: 300,
                fontSize: "22px",
              }}
            >
              {" "}
              {/* New Purchase Order -{" "} */}
              {isEditMode ? `${"Edit"}` : `${"New"}`} Purchase Order -
              <span style={{ color: "#0099ff" }}>{poNumber}</span>
            </h3>
            <button
              className="btn btn-default-outline"
              aria-label="Go Back"
              type="button"
              onClick={() => navigate("/purchaseOrder")}
              data-ember-action=""
              data-ember-action-668="668"
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>
        </div>
        <Form
          className="form-container"
          encType="multipart/form-data"
          onSubmit={handleSubmit(handleSendApprove)}
          style={{
            margin: 0,
            overflowY: "auto",
            height: "100%",
            paddingLeft: "0px",
            paddingTop: "12px",
            position: "relative",
          }}
        >
          <Row className="ms-0 w-100 mb-0">
            <Col md={2} style={{ borderRight: "1px solid #d4e7ed" }}>
              <div
                style={{ position: "sticky", top: "1rem" }}
                className=" mt-3"
              >
                <ul className=" ps-3" style={{ listStyle: "none" }}>
                  <li className="position-relative border-start ps-3 py-2 pt-0 ps-4">
                    <span
                      className="position-absolute  start-0 translate-middle bg-primary rounded-circle"
                      style={{
                        width: 10,
                        height: 10,
                        top: 11,
                        border: "1px solid #0099ff",
                      }}
                    ></span>
                    <a
                      href="#companyDetailsSection"
                      style={{ color: "#676262" }}
                    >
                      {" "}
                      Company Purchase Order{" "}
                    </a>
                  </li>

                  <li className="position-relative border-start ps-3 py-2 ps-4">
                    <span
                      className="position-absolute top-50 start-0 translate-middle bg-primary rounded-circle"
                      style={{ width: 10, height: 10 }}
                    ></span>
                    <a
                      href="#itemsDetailsSection"
                      style={{ color: "#676262" }}
                    >
                      {" "}
                      Items Details{" "}
                    </a>
                  </li>
                  <li className="position-relative border-start ps-3 py-2 ps-4">
                    <span
                      className="position-absolute top-50 start-0 translate-middle bg-primary rounded-circle"
                      style={{ width: 10, height: 10 }}
                    ></span>
                    <a
                      href="#termsAndConditionsSec"
                      style={{ color: "#676262" }}
                    >
                      {" "}
                      Terms & Conditions{" "}
                    </a>
                  </li>
                </ul>
                <hr />
              </div>
            </Col>

            <Col md={10} className="ps-3">
              <Row className="ms-0 w-100" id="companyDetailsSection">
                <h3
                  className=" mb-4 pt-3"
                  style={{
                    whiteSpace: "nowrap",
                    fontWeight: 300,
                    fontSize: "19px",
                  }}
                >
                  {" "}
                  Company Purchase Order
                </h3>

                <Row className="ms-0 w-100">
                  <Col md={6} className="ps-0">
                    <Col md={12}>
                      <Form.Group
                        className="mb-3 focus-z-index position-relative"
                        controlId="formContact"
                      >
                        <Form.Label
                          style={{ marginBottom: 1 }}
                          className="w-auto"
                        >
                          Contact <span className="text-danger">*</span>
                        </Form.Label>
                        <Controller
                          name="contact"
                          control={control}
                          rules={{ required: "Contact is required" }}
                          render={({ field }) => {
                            return (
                              <Select
                                {...field}
                                options={contactOptions}
                                placeholder="Select Contact"
                                classNamePrefix="react-select"
                                // Use custom component to show company name below contact name
                                components={{
                                  Option: CustomOption,
                                  MenuList
                                }}

                                value={
                                  contactOptions?.find(
                                    (opt) => opt.value === field.value
                                  ) || selectedContact
                                }
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "contact",
                                    selected,
                                    field.onChange
                                  )
                                }
                                styles={{
                                  placeholder: (provided) => ({
                                    ...provided,
                                    paddingLeft: "11px",
                                  }),
                                  // Add padding to shift the selected value
                                  singleValue: (provided) => ({
                                    ...provided,
                                    marginLeft: "15px !important", // Adjust this value as needed
                                  }),
                                  // Also style the input when typing
                                  input: (provided) => ({
                                    ...provided,
                                    paddingLeft: "15px",
                                  }),
                                }}
                                onAddNew={() =>
                                  setShowCreateContact(!showCreateContact)
                                }
                                //permission props
                                moduleType={"contact"}
                                canCreate={contactGrant?.isCreate}
                              />
                            )
                          }}
                        />

                        {errors.contact && (
                          <p
                            className="text-danger mt-1"
                            style={{ fontSize: "12px" }}
                          >
                            {errors.contact.message}
                          </p>
                        )}
                      </Form.Group>
                    </Col>
                    <Row>
                      <Col md={12}>
                        <Form.Group
                          className="mb-3 focus-z-index position-relative"
                          controlId="formCompanyName"
                        >
                          <Form.Label className="w-auto">
                            Reference
                          </Form.Label>
                          <Form.Control
                            {...register("reference")}
                            type="text"
                            placeholder="Enter Reference Number"
                          />
                          {errors.reference && (
                            <p
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors.reference.message}
                            </p>
                          )}
                          <img
                            src={infoImg}
                            alt=""
                            style={{
                              width: 25,
                              height: 25,
                              position: "absolute",
                              right: 10,
                              top: 13,
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <Form.Group
                          className="mb-3 focus-z-index position-relative"
                          controlId="formCompanyName"
                        >
                          <Form.Label className="w-auto">
                            Purchase order Date{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            {...register("purchaseOrderDate")}
                            type="date"
                            placeholder="Enter Date"
                          />
                          {errors.purchaseOrderDate && (
                            <p
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors.purchaseOrderDate.message}
                            </p>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group
                          className="mb-3 focus-z-index position-relative"
                          controlId="formCompanyName"
                        >
                          <Form.Label className="w-auto">
                            Expected Delivery Date{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            {...register("expectedDeliveryDate")}
                            type="date"
                            placeholder="Enter Date"
                          />
                          {errors.expectedDeliveryDate && (
                            <p
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors.expectedDeliveryDate.message}
                            </p>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group
                          className="mb-3 focus-z-index position-relative"
                          controlId="formContact"
                        >
                          <Form.Label className="w-auto">
                            PO Generated By{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Controller
                            name="poGeneratedBy"
                            control={control}
                            rules={{ required: "PO is required" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={leadOwnerOptions}
                                placeholder="Select PO generated by"
                                classNamePrefix="react-select"
                                value={
                                  leadOwnerOptions?.find(
                                    (opt) => opt.value === field.value
                                  ) || ""
                                }
                                onChange={(selected) =>
                                  handleSelectChange(
                                    "poGeneratedBy",
                                    selected,
                                    field.onChange
                                  )
                                }
                                styles={{
                                  placeholder: (provided) => ({
                                    ...provided,
                                    paddingLeft: "11px",
                                  }),
                                  ...customStyles,
                                }}
                              />
                            )}
                          />

                          {errors.poGeneratedBy && (
                            <p
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors.poGeneratedBy.message}
                            </p>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group
                          className="mb-3 focus-z-index position-relative"
                          controlId="formCompanyName"
                        >
                          <Form.Label className="w-auto">
                            GSTN Number <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            {...register("gstnNumber")}
                            type="text"
                            placeholder="Enter Name"
                          />
                          {errors.gstnNumber && (
                            <p
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors.gstnNumber.message}
                            </p>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <Form.Group
                          className="mb-3 focus-z-index position-relative"
                          controlId="formCompanyName"
                        >
                          <Form.Label className="w-auto">
                            Short Description
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <textarea
                            type="text"
                            {...register("shortDescription")}
                            className="form-control"
                            placeholder="Enter Name"
                          />
                          {errors.shortDescription && (
                            <p
                              className="text-danger mt-1"
                              style={{ fontSize: "12px" }}
                            >
                              {errors.shortDescription.message}
                            </p>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col
                    md={5}
                    className="mb-3 ms-3 ps-4"
                    style={{ borderLeft: "1px solid #dae8ed" }}
                  >
                    <div className=" mt-0 mb-2 col-md-12">
                      <div className="w-100 mb-4">
                        <p
                          className="mb-2 fs-13 "
                          style={{
                            color: "#4c526c",
                            textTransform: "uppercase",
                          }}
                        >
                          Billing Address{" "}
                          <span
                            style={{
                              display: "inline-block",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setAddressModal(true)
                              setDefaultFor("billing")
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faPen}
                              style={{ color: "#b7a3a3" }}
                              className="ms-1"
                            />
                          </span>
                        </p>
                        {billingAdd
                          .filter((c) => c.selected === "selected")
                          .map((c, index) => (
                            <div key={index}>
                              <p
                                className="mb-0 fs-13 text-dark "
                                style={{
                                  fontWeight: 400,
                                  textTransform: "capitalize",
                                }}
                              >
                                {c.address}
                              </p>
                              <p
                                className="mb-3 fs-13 text-dark "
                                style={{
                                  fontWeight: 400,
                                  textTransform: "capitalize",
                                }}
                              >
                                {c.city}, {c.state}, {c.country} -{" "}
                                {c.zipcode || "-"}
                              </p>
                            </div>
                          ))}
                      </div>
                      <div className="w-100">
                        <p
                          className="mb-2 fs-13"
                          style={{
                            color: "#4c526c",
                            textTransform: "uppercase",
                          }}
                        >
                          Shiping Address{" "}
                          <span
                            style={{
                              display: "inline-block",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setAddressModal(true)
                              setDefaultFor("shipping")
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faPen}
                              style={{ color: "#b7a3a3" }}
                              className="ms-1"
                            />
                          </span>
                        </p>
                        {billingAdd
                          .filter((c) => c.for === "shipping")
                          .map((c, index) => (
                            <div key={index}>
                              <p
                                className="mb-0 fs-13 text-dark "
                                style={{
                                  fontWeight: 400,
                                  textTransform: "capitalize",
                                }}
                              >
                                {c.address}
                              </p>
                              <p
                                className="mb-3 fs-13 text-dark "
                                style={{
                                  fontWeight: 400,
                                  textTransform: "capitalize",
                                }}
                              >
                                {c.city}, {c.state}, {c.country} -{" "}
                                {c.zipcode || "-"}
                              </p>
                            </div>
                          ))}
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr />
                <Row id="itemsDetailsSection">
                  <h3
                    className=" mb-3"
                    style={{
                      whiteSpace: "nowrap",
                      fontWeight: 300,
                      fontSize: "19px",
                    }}
                  >
                    {" "}
                    Items Details
                  </h3>

                  <Col md={12} className="pe-0">
                    <div
                      className="table-responsive quatationsTables mb-3 "
                      style={{ minHeight: "25rem" }}
                    >
                      <table className="table mb-0">
                        <thead style={{ zIndex: "2", marginTop: "0" }}>
                          <tr>
                            <th
                              className="text-start"
                              style={{ width: "15%" }}
                            >
                              Items Name
                            </th>
                            <th style={{ width: "10%" }} className="text-end">
                              Quantity
                            </th>
                            <th style={{ width: "11%" }} className="text-end">
                              Rate{" "}
                            </th>
                            <th style={{ width: "11%" }} className="text-end">
                              GST(
                              <i className="bi bi-percent"></i>)
                            </th>
                            <th style={{ width: "16%" }} className="text-end">
                              {" "}
                              Discount(
                              <i className="bi bi-percent"></i>/
                              <i className="ti ti-currency-rupee"></i>)
                            </th>
                            <th style={{ width: "11%" }} className="text-center">
                              Amount{" "}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {fields.map((field, index) => {
                            const hasDescription =
                              watch(`items.${index}.description`) &&
                              watch(`items.${index}.description`).trim() !==
                              ""
                            const shouldShowDescription =
                              addDescriptionMap[index] || hasDescription
                            return (
                              <>
                                <tr key={field.id}>
                                  <td className="text-start">
                                    <div>
                                      <Controller
                                        name={`items.${index}.item`}
                                        control={control}
                                        render={({ field: formField }) => (
                                          <div className="mt-0 focus-z-index">
                                            <Select
                                              {...formField}
                                              options={getFilteredOptions(
                                                index
                                              )}
                                              placeholder="Select Item"
                                              styles={customStyle}
                                              value={formField.value}
                                              onChange={(selected) => {
                                                formField.onChange(selected)
                                                if (selected) {
                                                  const product =
                                                    productOption?.find(
                                                      (p) =>
                                                        p.productId ===
                                                        selected.value
                                                    )
                                                  if (product) {
                                                    setValue(
                                                      `items.${index}.rate`,
                                                      String(
                                                        product.productPrice ||
                                                        0
                                                      )
                                                    )
                                                    setValue(
                                                      `items.${index}.gst`,
                                                      String(
                                                        product.productGST ||
                                                        0
                                                      )
                                                    )
                                                    setValue(
                                                      `items.${index}.amount`,
                                                      product.productPrice
                                                    )
                                                  }
                                                }
                                              }}
                                            />
                                          </div>
                                        )}
                                      />

                                      {errors.items?.[index]?.item && (
                                        <p
                                          className="text-danger mt-1"
                                          style={{ fontSize: "12px" }}
                                        >
                                          {errors.items[index].item.message}
                                        </p>
                                      )}

                                      <div className="d-flex align-items-center mt-2">
                                        <span
                                          className="me-2"
                                          style={{
                                            cursor: "pointer",
                                            color: "#0099ff",
                                            fontSize: "12px",
                                          }}
                                          onClick={() =>
                                            setAddDescriptionMap((prev) => ({
                                              ...prev,
                                              [index]: !prev[index],
                                            }))
                                          }
                                        >
                                          <FontAwesomeIcon
                                            icon={
                                              shouldShowDescription
                                                ? faXmark
                                                : faPlus
                                            }
                                            className="me-1"
                                          />{" "}
                                          {shouldShowDescription
                                            ? "Cancel"
                                            : "Add Description"}
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <Controller
                                      name={`items.${index}.quantity`}
                                      control={control}
                                      render={({ field: qtyField }) => (
                                        <input
                                          {...qtyField}
                                          type="number"
                                          className="normalInputItem text-end"
                                          placeholder="00"
                                          onChange={(e) => {
                                            let value = e.target.value
                                            value = value.replace(
                                              /[^0-9.]/g,
                                              ""
                                            )
                                            const parts = value.split(".")
                                            if (parts.length > 2) {
                                              value =
                                                parts[0] +
                                                "." +
                                                parts.slice(1).join("")
                                            }
                                            if (
                                              value.length > 1 &&
                                              value.startsWith("0") &&
                                              !value.startsWith("0.")
                                            ) {
                                              value = value.replace(/^0+/, "")
                                            }
                                            qtyField.onChange(
                                              value === ""
                                                ? ""
                                                : Number.parseFloat(value)
                                            )
                                            handleUpdateAmount(index)
                                          }}
                                        />
                                      )}
                                    />
                                    {errors.items?.[index]?.quantity && (
                                      <p
                                        className="text-danger mt-1"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {errors.items[index].quantity.message}
                                      </p>
                                    )}
                                  </td>
                                  <td>
                                    <Controller
                                      name={`items.${index}.rate`}
                                      control={control}
                                      render={({ field: rateField }) => (
                                        <input
                                          {...rateField}
                                          type="text"
                                          className="normalInputItem text-end"
                                          placeholder="00.00"
                                          readOnly
                                        />
                                      )}
                                    />
                                    {errors.items?.[index]?.rate && (
                                      <p
                                        className="text-danger mt-1"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {errors.items[index].rate.message}
                                      </p>
                                    )}
                                  </td>

                                  <td>
                                    <Controller
                                      name={`items.${index}.gst`}
                                      control={control}
                                      render={({ field: gstField }) => (
                                        <input
                                          {...gstField}
                                          type="text"
                                          className="normalInputItem text-end"
                                          placeholder="0.00"
                                          style={{ paddingRight: 23 }}
                                          readOnly
                                        />
                                      )}
                                    />
                                    <i
                                      className="bi bi-percent"
                                      style={{
                                        // position: "absolute",
                                        marginLeft: "-20px",
                                        marginTop: "8px",
                                      }}
                                    ></i>
                                    {errors.items?.[index]?.gst && (
                                      <p
                                        className="text-danger mt-1"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {errors.items[index].gst.message}
                                      </p>
                                    )}
                                  </td>
                                  <td>
                                    <div className="d-flex gap-1">
                                      <Controller
                                        name={`items.${index}.discount`}
                                        control={control}
                                        render={({
                                          field: discountField,
                                        }) => (
                                          <input
                                            {...discountField}
                                            type="text"
                                            className="normalInputItem text-end"
                                            placeholder="0.00"
                                            value={discountField.value ?? ""}
                                            onChange={(e) => {
                                              let value = e.target.value
                                              value = value.replace(
                                                /[^0-9.]/g,
                                                ""
                                              )
                                              const parts = value.split(".")
                                              if (parts.length > 2) {
                                                value =
                                                  parts[0] +
                                                  "." +
                                                  parts.slice(1).join("")
                                              }
                                              if (
                                                value.length > 1 &&
                                                value.startsWith("0") &&
                                                !value.startsWith("0.")
                                              ) {
                                                value = value.replace(
                                                  /^0+/,
                                                  ""
                                                )
                                              }
                                              discountField.onChange(
                                                value === ""
                                                  ? ""
                                                  : Number.parseFloat(value)
                                              )
                                              const discountType = watch(
                                                `items.${index}.discountType`
                                              )
                                              validateItemDiscount(
                                                index,
                                                value,
                                                discountType
                                              )
                                              handleUpdateAmount(index)
                                            }}
                                          />
                                        )}
                                      />

                                      <Controller
                                        name={`items.${index}.discountType`}
                                        control={control}
                                        defaultValue={"PERCENT"}
                                        render={({ field: typeField }) => (
                                          <div style={{ width: "100px" }}>
                                            <Select
                                              {...typeField}
                                              options={itemDiscountOptions}
                                              classNamePrefix=""
                                              isSearchable={false}
                                              onChange={(selectedOption) => {
                                                typeField.onChange(
                                                  selectedOption.value
                                                )
                                                const discountValue = watch(
                                                  `items.${index}.discount`
                                                )
                                                validateItemDiscount(
                                                  index,
                                                  discountValue,
                                                  selectedOption.value
                                                )
                                                handleUpdateAmount(index)
                                              }}
                                              value={itemDiscountOptions.find(
                                                (opt) =>
                                                  opt.value ===
                                                  typeField.value
                                              )}
                                              styles={{
                                                control: (base) => ({
                                                  ...base,
                                                  minHeight: 35,
                                                  paddingLeft: 4,
                                                }),
                                                indicatorsContainer: (
                                                  base
                                                ) => ({
                                                  ...base,
                                                  paddingRight: 4,
                                                }),
                                                dropdownIndicator: (
                                                  base
                                                ) => ({
                                                  ...base,
                                                  padding: 2,
                                                }),
                                              }}
                                            />
                                          </div>
                                        )}
                                      />
                                    </div>
                                    {discountErrors[index] && (
                                      <p
                                        className="text-danger mt-1"
                                        style={{
                                          fontSize: "10px",
                                          position: "absolute",
                                          whiteSpace: "nowrap",
                                          zIndex: 10,
                                          backgroundColor: "white",
                                          padding: "2px 4px",
                                          border: "1px solid #dc3545",
                                          borderRadius: "3px",
                                        }}
                                      >
                                        {discountErrors[index]}
                                      </p>
                                    )}
                                  </td>
                                  <td className="text-end">
                                    <div className="d-flex gap-2 align-items-center justify-content-center">
                                      <div
                                        className="fs-14 text-end normalInputItem"
                                        style={{
                                          fontWeight: 500,
                                          fontSize: 14,
                                        }}
                                      >

                                        {formatToINR(watch(`items.${index}.amount`) ||
                                          "0.00")}
                                      </div>

                                      {fields.length > 1 && (
                                        <>
                                          <style>
                                            {`
                                                .abc {
                                                  width: 1px;
                                                  background: lightblue;
                                                  height: 28px;
                                                  margin-bottom: 28px !important;
                                                }
                                              `}
                                          </style>
                                          <p className="abc"></p>
                                          <Button
                                            variant="link"
                                            className="text-danger ms-0 p-0 "
                                            style={{ marginBottom: "28px" }}
                                            onClick={() =>
                                              handleDeleteRow(index)
                                            }
                                            title="Delete Row"
                                          >
                                            <FontAwesomeIcon icon={faXmark} />
                                          </Button>
                                        </>
                                      )}
                                    </div>
                                  </td>
                                </tr>

                                {shouldShowDescription && (
                                  <tr>
                                    <td colSpan={6} className="p-0 border-0">
                                      <div className="px-2 py-2">
                                        <Controller
                                          name={`items.${index}.description`}
                                          control={control}
                                          render={({ field: descField }) => (
                                            <textarea
                                              {...descField}
                                              className="normalTextarea"
                                              placeholder="Enter a description about item."
                                            />
                                          )}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </>
                            )
                          })}
                          <tr>
                            <th className="text-start bg-transparent vertical-top">
                              <div>
                                <a
                                  className="mb-0 fs-13 d-flex gap-2 align-items-center"
                                  onClick={addRow}
                                  style={{
                                    borderRadius: 4,
                                    color: " rgb(89 86 86)",
                                    background: "#f9f9fb",
                                    padding: "8px 10px",
                                    fontSize: 13,
                                    width: "fit-content",
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faPlus}
                                    style={{
                                      border: "1px solid #0099ff",
                                      background: "#0099ff",
                                      color: "#fff",
                                      padding: 4,
                                      borderRadius: "50%",
                                      height: 11,
                                      width: 11,
                                    }}
                                  />{" "}
                                  Add New Row
                                </a>
                              </div>
                            </th>
                            <th
                              colSpan={6}
                              className="text-start bg-transparent"
                            ></th>
                          </tr>
                          <tr>
                            <th
                              colSpan={2}
                              className="text-start bg-transparent border-0 vertical-top w-100"
                            // style={{ verticalAlign: "bottom" }}
                            >
                              <div className="mt-0">
                                <p
                                  className="ps-1 mb-2 fs-13"
                                  style={{ fontWeight: 400 }}
                                >
                                  Customer Note
                                </p>
                                <Controller
                                  name="customerNote"
                                  control={control}
                                  render={({ field }) => (
                                    <textarea
                                      {...field}
                                      placeholder="Looking forward for your business."
                                      className="normalTextareaQuotation"
                                    // style={styles.customerNote}
                                    />
                                  )}
                                />
                              </div>
                            </th>
                            <th
                              colSpan={4}
                              className="text-start bg-transparent border-0"
                            // style={{ height: "10rem" }}
                            >
                              <div
                                className=" h-100 p-3"
                                style={{
                                  borderRadius: 5,
                                  background: "#f9f9fb",
                                }}
                              >
                                {/* subtotal value render */}
                                <div className="row sub-total mb-2 text-semibold ">
                                  <div className="total-label fs-14 fw-500 col-md-6 d-flex align-items-center">
                                    Sub Total
                                  </div>
                                  <div className="total-amount text-end fs-14 fw-500 col-md-6 d-flex gap-1 align-items-center justify-content-end">
                                    {formatToINR(subtotal || 0)}
                                  </div>
                                </div>

                                {/* special discount value and its discount type */}
                                <div
                                  className="row sub-total mb-4"
                                  style={{ fontWeight: 400 }}
                                >
                                  <div className="total-label col-md-4 d-flex align-items-center text-secondary fs-13 fw-400">
                                    Special Discount
                                  </div>
                                  <div className="total-amount text-center col-md-5 d-flex gap-1">
                                    <div style={{ position: "relative" }}>
                                      <Controller
                                        name={`specialDiscount`}
                                        control={control}
                                        defaultValue={0}
                                        render={({ field }) => (
                                          <input
                                            style={{ width: "118px" }}
                                            {...field}
                                            type="text"
                                            placeholder="0.00"
                                            className="normalInput text-end"
                                            value={field.value}
                                            onChange={(e) => {
                                              const value =
                                                Number(e.target.value) || 0
                                              field.onChange(value)
                                              const discountType = watch(
                                                "specialDiscountType"
                                              )
                                              validateSpecialDiscount(
                                                value,
                                                discountType
                                              )
                                            }}
                                          />
                                        )}
                                      />
                                      {/* Display validation error for special discount */}
                                      {specialDiscountError && (
                                        <p
                                          className="text-danger mt-1"
                                          style={{
                                            fontSize: "10px",
                                            position: "absolute",
                                            whiteSpace: "nowrap",
                                            zIndex: 10,
                                            backgroundColor: "white",
                                            padding: "2px 4px",
                                            border: "1px solid #dc3545",
                                            borderRadius: "3px",
                                          }}
                                        >
                                          {specialDiscountError}
                                        </p>
                                      )}
                                    </div>
                                    <Controller
                                      name={`specialDiscountType`}
                                      control={control}
                                      defaultValue={"PERCENT"}
                                      render={({ field: typeField }) => (
                                        <div style={{ width: "80px" }}>
                                          <Select
                                            {...typeField}
                                            options={discountTypeOptions}
                                            classNamePrefix=""
                                            isSearchable={false}
                                            onChange={(selectedOption) => {
                                              typeField.onChange(
                                                selectedOption.value
                                              )
                                              const discountValue =
                                                watch("specialDiscount")
                                              validateSpecialDiscount(
                                                discountValue,
                                                selectedOption.value
                                              )
                                            }}
                                            value={discountTypeOptions.find(
                                              (opt) =>
                                                opt.value === typeField.value
                                            )}
                                            styles={{
                                              control: (base) => ({
                                                ...base,
                                                minHeight: 35,
                                                paddingLeft: 4,
                                                borderColor: "lightblue",
                                                borderRadius: 4,
                                                cursor: "pointer",
                                              }),
                                              dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: 2,
                                              }),
                                              indicatorsContainer: (
                                                base
                                              ) => ({
                                                ...base,
                                                paddingRight: 4,
                                              }),
                                            }}
                                          />
                                        </div>
                                      )}
                                    />
                                  </div>

                                  <div className="total-amount text-end text-secondary fs-13 fw-400 col-md-3 d-flex align-items-center justify-content-end">
                                    - {formatToINR(discountMoney)}
                                  </div>
                                </div>

                                {/* gst mapping */}
                                {gstCategories?.map((category) => (
                                  <div
                                    className="row sub-total mb-2 d-flex justify-content-between"
                                    style={{ fontWeight: 400 }}
                                    key={category.gstCategory}
                                  >
                                    <div className="total-label col-md-4 d-flex align-items-center text-secondary fs-13 fw-400">
                                      GST({category.gstCategory})
                                    </div>

                                    <div className="total-amount text-end text-secondary fw-400 col-md-3 fs-13 d-flex align-items-center justify-content-end">
                                      {formatToINR(
                                        category.totalAmt?.toFixed(2)
                                      )}
                                    </div>
                                  </div>
                                ))}
                                <hr />
                                {/* grand total of all the final amount  */}
                                <div className="row sub-total ">
                                  <div className="total-label fs-14 fw-500 col-md-6">
                                    Grand Total
                                    {/* ({" "}
                                        <FontAwesomeIcon
                                          icon={faIndianRupeeSign}
                                          className="fs-13"
                                        />
                                        {grandTotal.toLocaleString()}
                                        ) */}
                                  </div>
                                  <div className="total-amount text-end fs-14 fw-500  col-md-6">
                                    {formatToINR(grandTotal)}
                                  </div>
                                </div>
                              </div>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Col>
                </Row>

                <hr />

                <Row id="termsAndConditionsSec">
                  <Col md={8}>
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                      }}
                    >
                      {" "}
                      Terms & Conditions{" "}
                    </h3>

                    <Form.Group className="mb-3" controlId="formCompanyName">
                      <textarea
                        {...register("termsConditions")}
                        className=" normalTextarea"
                        type="text"
                        placeholder="Enter the terms and conditions of your business to be displayed in your transaction"
                        style={{ minHeight: 81 }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4} className="mb-3">
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                      }}
                    >
                      {" "}
                      Add Attachment{" "}
                    </h3>
                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={handleDrop}
                      // onClick={handleClickButton}
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "10px",
                        padding: "10px 20px",
                        textAlign: "center",
                        background: isDragging ? "#e0f3ff" : "#f9f9f9",
                        width: "100%",
                        maxWidth: "400px",
                        cursor: "pointer",
                      }}
                    >
                      <p style={{ marginBottom: "5px", color: "#666" }}>
                        {file
                          ? <>{`Selected: ${file.name}`}   <IconXboxX
                            stroke={2}
                            size={18}
                            style={{ stroke: "red", cursor: "pointer" }}
                            onClick={() => setFile(null)}
                          /></>
                          : "Drag & drop or click to upload a file"}
                      </p>

                      <button
                        type="button"
                        onClick={handleClickButton}
                        style={{
                          padding: "5px 20px",
                          backgroundColor: "#0099ff",
                          color: "#fff",
                          borderRadius: "5px",
                          cursor: "pointer",
                          border: "none",
                          fontSize: "16px",
                        }}
                      >
                        <FontAwesomeIcon icon={faCloudUpload} /> Browse File
                      </button>

                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleChange}
                        style={{ display: "none" }}
                      />
                    </div>
                    <div
                      style={{
                        // marginTop: "10px",
                        width: "100%",
                        maxWidth: "400px",
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          color: "#a5a5a5",
                          fontSize: "11px",
                          fontWeight: "400",
                          margin: 0,
                        }}
                      >
                        Accepted file types are .jpg, .png, .pdf and .jpeg max file
                        size 5MB
                      </p>
                    </div>
                    {existingFile?.url && !file && (
                      <div
                        style={{
                          marginTop: "15px",
                          padding: "10px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          background: "#f1f1f1",
                          textAlign: "center",
                        }}
                      >
                        <a
                          href={existingFile?.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#007bff",
                            fontWeight: "500",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          Click to watch old file
                        </a>
                      </div>
                    )}
                  </Col>
                  {/* <Col md={4} className="mb-3">
                    <h3
                      className=" mb-3"
                      style={{
                        whiteSpace: "nowrap",
                        fontWeight: 300,
                        fontSize: "19px",
                      }}
                    >
                      {" "}
                      Add Attachment{" "}
                    </h3>
                    <div
                      style={{
                        border: "2px dashed #ccc",
                        borderRadius: "10px",
                        padding: "10px 20px",
                        textAlign: "center",
                        background: "#f9f9f9",
                        width: "100%",
                        maxWidth: "400px",
                        margin: "5px auto",
                      }}
                    >
                      <p style={{ marginBottom: "5px", color: "#666" }}>
                        {file
                          ? `Selected: ${file.name}`
                          : "Drag & drop or click to upload a file"}
                      </p>

                      <button
                        type="button"
                        onClick={handleClickButton}
                        style={{
                          padding: "5px 20px",
                          backgroundColor: "#0099ff",
                          color: "#fff",
                          borderRadius: "5px",
                          cursor: "pointer",
                          border: "none",
                          fontSize: "16px",
                        }}
                      >
                        <FontAwesomeIcon icon={faCloudUpload} /> Browse File
                      </button>

                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleChange}
                        style={{ display: "none" }}
                      />
                    </div>
                    <div
                      style={{
                        // marginTop: "10px",
                        width: "100%",
                        maxWidth: "400px",
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          color: "#a5a5a5",
                          fontSize: "11px",
                          fontWeight: "400",
                          margin: 0,
                        }}
                      >
                        Accepted file types are .jpg, .png, .pdf, max file size
                        2MB
                      </p>
                    </div>
                  </Col> */}
                </Row>

                <hr />
              </Row>
              <div className="zb-txn-form mb-4 text-center">
                <div className="text-muted fs-14" style={{ marginTop: 10 }}>
                  <span style={{ fontWeight: 400, color: "#b3b3b3" }}>
                    Additional Fields :{" "}
                  </span>{" "}
                  Start adding custom fields for your purchase orders by going
                  to{" "}
                  <i>
                    Settings <FontAwesomeIcon icon={faArrowRightLong} />{" "}
                    Purchase Orders
                  </i>
                  .
                </div>
              </div>

              <p style={{ height: "5rem" }}></p>

              <div
                className="bg-white position-sticky "
                style={{
                  // paddingRight: "2rem",
                  // height: 75,
                  // bottom: "1rem",
                  // right: "1.4rem",
                  // display: "flex",
                  // alignItems: "center",
                  // justifyContent: "end",
                  // width: "93.4%",
                  // zIndex: 11,
                  // borderTop: "1px solid lightblue",

                  paddingTop: "13px",
                  paddingBottom: "15px",
                  paddingRight: "17px",
                  // height: 75,
                  bottom: "67.5px",
                  // right: "20.5px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                  // width: "93.4%",
                  zIndex: 11,
                  borderTop: "1px solid lightblue",
                }}
              >
                <Button
                  className="btn btn-default-outline me-2"
                  onClick={() => {
                    setDraftClicked(false)
                    reset()
                    navigate("/purchaseOrder")
                  }}
                >
                  {" "}
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={() => {
                    setDraftClicked(true)
                    // handleSendApprove()
                  }}
                  className="btn btn-primary me-2">
                  {" "}
                  Save As Draft
                </Button>
                <Button type="submit" className="btn btn-default">
                  Send To Approve
                </Button>
              </div>
            </Col>
          </Row>
        </Form>

        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 18, fontWeight: 400 }}>
              Create Purchase Order Series
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form action="" method="post" className="form-container">
              <div className="form-check ps-1 mb-1 d-flex align-items-center ">
                <input
                  type="text"
                  value=""
                  id="feeReceiptId"
                  name="feeReceiptId"
                  hidden
                />
                <input
                  type="radio"
                  name=""
                  id=""
                  className="me-2"
                  style={{ width: 17, height: 17 }}
                />

                <p className="form-label mt-1">NG-2025-08-100</p>
              </div>
              <div className="form-check mb-1 ps-1 d-flex align-items-center">
                <input
                  type="radio"
                  name=""
                  id=""
                  className="me-2"
                  style={{ width: 17, height: 17 }}
                />
                <p className="form-label mt-1">NG-08-2025-100</p>
              </div>
              <div className="form-check ps-1 mb-1 d-flex align-items-center">
                <input
                  type="radio"
                  name=""
                  id=""
                  className="me-2"
                  style={{ width: 17, height: 17 }}
                />
                <p className="form-label mt-1">NG-2025-100</p>
              </div>
              <div className="form-check ps-1 mb-1 d-flex align-items-center">
                <input
                  type="radio"
                  name=""
                  id=""
                  className="me-2"
                  style={{ width: 17, height: 17 }}
                />
                <p className="form-label mt-1">NG-100</p>
              </div>
              <div className="input-div position-relative focus-z-index mt-3 mb-2">
                <label for="incrementalNo" className="form-label">
                  Enter Incremental Number Here: <span>*</span>
                </label>
                <input
                  type="number"
                  name="incrementalNumber"
                  className="form-control prefix-element "
                  id="incrementalNumber"
                  placeholder="Enter Any 4 Digits"
                  required=""
                />
              </div>
              <div className="input-div position-relative focus-z-index mt-3 mb-4">
                <label for="summaryPermission" className="form-label">
                  Want Course Fee Summary? <span>*</span>
                </label>
                <select
                  name="summaryPermission"
                  id="summaryPermission"
                  className="form-select"
                  onchange=";"
                  required=""
                >
                  <option value="1" selected="selected">
                    Yes
                  </option>
                  <option value="0">No</option>
                </select>
              </div>
              <Modal.Footer>
                <Button variant="default-outline" onClick={handleClose}>
                  Close
                </Button>
                <Button variant="default" onClick={() => alert("Saved!")}>
                  Save Changes
                </Button>
              </Modal.Footer>
            </form>
          </Modal.Body>
        </Modal>

        <PurchaseAddressModal
          show={addressModal}
          handleClose={() => setAddressModal(false)}
          defaultFor={defaultFor}
          billing_address={billingAdd}
          handleFetch={fetchBillingAddress}
        ></PurchaseAddressModal>
      </div>
      {showCreateContact && (
        <ContactForm
          show={showCreateContact}
          setShow={setShowCreateContact}
          setRecentContactId={setRecentContact}
          companyGrants={companyGrants}
          country={country}
          masterGrant={masterGrant}
        />
      )}
    </>
  )
}
